import { DrawerContentContainer } from '../../../../AdminDrawer/AdminDrawer.styles';
import EmployeeInfo from '../../../../EmployeeInfo/EmployeeInfo';
import {
  Section,
  SectionTitle,
  InfoGrid,
  InfoItem,
  Label,
  Value,
  StatusBadge,
  EmptyValue,
} from './EmployeePersonalDetailsView.styles';
import { Typography } from '@mui/material';

const EmployeePersonalDetailsView = ({ employee }) => {
  const { address, city, emergencyName, emergencyPhone, emergencyRelationship, phone, state, zip } =
    employee.personalDetails || {};
  const email = employee.email;
  const activeStatus = employee.isActive;

  const renderValue = (value) => {
    if (!value || value.trim() === '') {
      return <EmptyValue variant="body2">Not provided</EmptyValue>;
    }
    return <Value variant="body2">{value}</Value>;
  };

  return (
    <DrawerContentContainer alignment="center">
      <EmployeeInfo employee={employee} headerType="name" />
      <Typography component={StatusBadge} variant="body2" isActive={activeStatus}>
        {activeStatus ? 'Active' : 'Inactive'}
      </Typography>

      <Section>
        <SectionTitle variant="title2">Personal Details</SectionTitle>
        <InfoGrid>
          <InfoItem>
            <Label variant="caption">Address</Label>
            {renderValue(address)}
          </InfoItem>
          <InfoItem>
            <Label variant="caption">City</Label>
            {renderValue(city)}
          </InfoItem>
          <InfoItem>
            <Label variant="caption">State</Label>
            {renderValue(state)}
          </InfoItem>
          <InfoItem>
            <Label variant="caption">ZIP Code</Label>
            {renderValue(zip)}
          </InfoItem>
          <InfoItem>
            <Label variant="caption">Phone</Label>
            {renderValue(phone)}
          </InfoItem>
          <InfoItem>
            <Label variant="caption">Email</Label>
            {renderValue(email)}
          </InfoItem>
        </InfoGrid>
      </Section>

      <Section>
        <SectionTitle variant="title2">Emergency Contact</SectionTitle>
        <InfoGrid>
          <InfoItem>
            <Label variant="caption">Name</Label>
            {renderValue(emergencyName)}
          </InfoItem>
          <InfoItem>
            <Label variant="caption">Phone</Label>
            {renderValue(emergencyPhone)}
          </InfoItem>
          <InfoItem>
            <Label variant="caption">Relationship</Label>
            {renderValue(emergencyRelationship)}
          </InfoItem>
        </InfoGrid>
      </Section>
    </DrawerContentContainer>
  );
};

export default EmployeePersonalDetailsView;
